export default "__VITE_ASSET__BOpbVH3L__"